import { render, staticRenderFns } from "./TempCourse.vue?vue&type=template&id=e006f756&scoped=true&"
import script from "./TempCourse.vue?vue&type=script&lang=js&"
export * from "./TempCourse.vue?vue&type=script&lang=js&"
import style0 from "./TempCourse.vue?vue&type=style&index=0&id=e006f756&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e006f756",
  null
  
)

export default component.exports